import styled from 'styled-components';

export const DesktopSidebarWithSnowflakeWrapper = styled('section')`
  width: ${({ theme }) => theme.sidebarWidth}px;
  padding: ${({ theme }) => `0 ${theme.x3spacePx}px 0 0`};
`;
